import type { ProfileIdentityValidationItem } from "models";

export type ProfileIdentityFieldErrors = {
  pronouns?: string;
  pronunciation?: string;
};

function isValidationItem(x: unknown): x is ProfileIdentityValidationItem {
  return (
    typeof x === "object" &&
    x !== null &&
    typeof (x as ProfileIdentityValidationItem).description === "string"
  );
}

export function parseProfileIdentityValidationErrors(
  data: unknown
): ProfileIdentityFieldErrors {
  if (!Array.isArray(data)) {
    return {};
  }

  const out: ProfileIdentityFieldErrors = {};

  for (const item of data) {
    if (!isValidationItem(item)) {
      continue;
    }

    const { description } = item;
    const lower = description.toLowerCase();

    if (lower.includes("pronunciation")) {
      out.pronunciation = description;
    } else if (lower.includes("pronouns")) {
      out.pronouns = description;
    }
  }

  return out;
}
